import React from 'react'

import Item from './Item'
import PageLink from './PageLink'

const PageLinkItem = (props) => (
  <Item>
    <PageLink {...props} />
  </Item>
)

export default PageLinkItem
